<div matDialogTitle>Upload Attachment{{uploadMultiple ? 's' : ''}}</div>
<mat-dialog-content>
  <p-fileUpload name="file" url="{{uploadUrl}}" (onBeforeUpload)="onBeforeUpload($event)"
    (onSelect)="onSelect($event)" (onUpload)="onUpload($event)" (onError)="onError($event)" [accept]="accept" invalidFileTypeMessageSummary="Invalid file type, "
    invalidFileTypeMessageDetail=' only accepts images, pdf, text, csv, ms-excel, xml, and spreadsheets.' [disabled]="disableUpload"
    [showCancelButton]="!disableUpload" [multiple]="uploadMultiple"

    (onRemove)="onRemove($event)">
    <ng-template #empty>
      @if (isShowDragContent) {
        <p class="content-message">Drop  Your File Here</p>
      }
    </ng-template>
  </p-fileUpload>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-flex-end gap-20">
  <button mat-raised-button matDialogClose class="flex-20">Cancel</button>
</mat-dialog-actions>
